import { cx } from "@suse-o11y/class-variance";
import { Slot, type Slottable } from "@suse-o11y/slot";
import React from "react";

import styles from "./_divider.module.css";

export interface DividerProps extends Slottable, React.HTMLAttributes<HTMLElement> {}

export const Divider = React.forwardRef<HTMLDivElement, DividerProps>(
	({ asChild = false, className, ...props }, ref) => {
		const Content = asChild ? Slot : "div";

		return <Content className={cx(styles.divider, className)} ref={ref} {...props} />;
	},
);

if (import.meta.env.DEV) {
	Divider.displayName = "Divider";
}
